import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import I18n from 'I18n';
import { WarningIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getToolTipString = (emailAddress, validationData) => {
  if (!validationData.isEmailValid) {
    return I18n.text('cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.invalidEmailTooltip');
  }
  return emailAddress;
};
const RecipientTag = props => {
  const {
      option: {
        name,
        address,
        validationData
      }
      // https://tools.hubteamqa.com/ui-library/show/UIComponents/input/UISelect#uiselect/custom-item
      // Your itemComponent can use the option prop directly and must pass the rest of the received props to its root element.
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const tagTextContent = name || address;
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, rest, {
    title: getToolTipString(address, validationData),
    children: /*#__PURE__*/_jsxs("span", {
      children: [tagTextContent, !validationData.isEmailValid && /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(WarningIcon, {
          size: "300"
        })
      })]
    })
  }));
};
export default RecipientTag;